var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExplorerMembers',_vm._b({},'ExplorerMembers',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }